/**
 * Hinweis fuer Bereiche, die in dieser Instanz noch nicht freigegeben sind (config.json `comingSoon`).
 * Der Menuepunkt bleibt, die Seite zeigt nur diesen Hinweis.
 */
interface ComingSoonProps {
  /** Name des Bereichs, z. B. "Aria". */
  feature: string
}

export default function ComingSoon({ feature }: ComingSoonProps) {
  return (
    <section className="aria-settings-card" role="status" aria-label={`${feature}: Demnächst verfügbar`}>
      <h3>{feature}</h3>
      <p className="aria-settings-note">Demnächst verfügbar.</p>
    </section>
  )
}
